import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ProviderStateService } from '../services/provider-state.service';

@Injectable({
  providedIn: 'root'
})
export class ReturnUrlGuard implements CanActivate {
  slug: string = "";
  constructor(private router: Router,
    private providerstateService: ProviderStateService
  ) {
    this.slug = this.providerstateService.getProviderSlug();
  }

  // : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {

    if (sessionStorage.getItem('userid') &&
      sessionStorage.getItem('email') &&
      sessionStorage.getItem('name') &&
      sessionStorage.getItem('authtoken')) {
      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page with the return url

    this.router.navigate(['/' + this.slug + '/'], { queryParams: { returnUrl: state.url } });
    return false;
  }

}
